import { API } from 'aws-amplify';
import { AuthorizeData } from '../types';

/** React Query key shared by every /authorize query in the app */
export const AUTHORIZE_QUERY_KEY = ['ContractingAPI', '/authorize'];

/**
 * Fetch the signed-in user's Agent or Staff record and IMO from the
 * Contracting API. This is the same call alliance-contracting makes, and
 * it feeds the App Bar user control, the user menu and System Screens.
 */
export async function fetchAuthorize() {
  const response: { data: AuthorizeData } = await API.post(
    'ContractingAPI',
    '/authorize',
    {},
  );
  return response.data;
}

/** HTTP status of a failed Amplify (axios) request, if there is one */
export function getErrorStatus(params: { error: unknown }) {
  return (params.error as { response?: { status?: number } })?.response?.status;
}
